import React, { useEffect, useState } from "react";

function Rightside() {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    // fetch("http://localhost/myapp/api/getNotices.php")
    fetch("https://spst.in/myapp/api/getNotices.php")
   
      .then((res) => res.json())
      .then((data) => {
        setNotices(data);
      })
      .catch((err) => console.log("Error:", err));
  }, []);

  return (
    <div style={{border:'1px solid maroon;'}}>
      <h3 style={{fontWeight:'800',color:'maroon'}} >Updates</h3>
      <p style={{borderBottom:'1px solid maroon',padding:'10px',fontWeight:'800'}}><i class="fa fa-angle-double-right" aria-hidden="true"></i> <a href="./images/guard.pdf" style={{textDecoration:'none',cursor:'pointer'}}>NOTIFICATION FOR THE POST OF GUARD COMMANDER ON CONTRACT BASIS</a></p>
      {notices.length === 0 ? (
        <p>No updates found</p>
      ) : (
        notices.map((item) => (
          <div key={item.id}>
           <p style={{borderBottom:'1px solid maroon',padding:'10px',fontWeight:'800'}}> <i class="fa fa-angle-double-right" aria-hidden="true"></i>  {item.title}</p>
          </div>
        ))
      )}
    </div>
  );
}

export default Rightside;
